/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Failed_To_Start_Checkout_PleaInputs */

const en_failed_to_start_checkout_plea = /** @type {(inputs: Failed_To_Start_Checkout_PleaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to start checkout. Please try again.`)
};

const es_failed_to_start_checkout_plea = /** @type {(inputs: Failed_To_Start_Checkout_PleaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al iniciar el proceso de pago. Por favor, inténtalo de nuevo.`)
};

const fr_failed_to_start_checkout_plea = /** @type {(inputs: Failed_To_Start_Checkout_PleaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec du démarrage de la commande. Veuillez réessayer.`)
};

const de_failed_to_start_checkout_plea = /** @type {(inputs: Failed_To_Start_Checkout_PleaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Starten der Kasse. Bitte versuche es erneut.`)
};

const ja_failed_to_start_checkout_plea = /** @type {(inputs: Failed_To_Start_Checkout_PleaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チェックアウトの開始に失敗しました。もう一度お試しください。`)
};

const zh_failed_to_start_checkout_plea = /** @type {(inputs: Failed_To_Start_Checkout_PleaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法启动结账。请再试一次。`)
};

const ar_failed_to_start_checkout_plea = /** @type {(inputs: Failed_To_Start_Checkout_PleaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فشل في بدء عملية الدفع. يرجى المحاولة مرة أخرى.`)
};

const id_failed_to_start_checkout_plea = /** @type {(inputs: Failed_To_Start_Checkout_PleaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal memulai checkout. Silakan coba lagi.`)
};

const it_failed_to_start_checkout_plea = /** @type {(inputs: Failed_To_Start_Checkout_PleaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile avviare il checkout. Per favore, riprova.`)
};

const ru_failed_to_start_checkout_plea = /** @type {(inputs: Failed_To_Start_Checkout_PleaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось начать оформление заказа. Пожалуйста, попробуйте снова.`)
};

const pt_failed_to_start_checkout_plea = /** @type {(inputs: Failed_To_Start_Checkout_PleaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao iniciar o checkout. Por favor, tente novamente.`)
};

const ko_failed_to_start_checkout_plea = /** @type {(inputs: Failed_To_Start_Checkout_PleaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`결제를 시작하지 못했습니다. 다시 시도해 주세요.`)
};

/**
* | output |
* | --- |
* | "Failed to start checkout. Please try again." |
*
* @param {Failed_To_Start_Checkout_PleaInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const failed_to_start_checkout_plea = /** @type {((inputs?: Failed_To_Start_Checkout_PleaInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failed_To_Start_Checkout_PleaInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_failed_to_start_checkout_plea(inputs)
	if (locale === "es") return es_failed_to_start_checkout_plea(inputs)
	if (locale === "fr") return fr_failed_to_start_checkout_plea(inputs)
	if (locale === "de") return de_failed_to_start_checkout_plea(inputs)
	if (locale === "ja") return ja_failed_to_start_checkout_plea(inputs)
	if (locale === "zh") return zh_failed_to_start_checkout_plea(inputs)
	if (locale === "ar") return ar_failed_to_start_checkout_plea(inputs)
	if (locale === "id") return id_failed_to_start_checkout_plea(inputs)
	if (locale === "it") return it_failed_to_start_checkout_plea(inputs)
	if (locale === "ru") return ru_failed_to_start_checkout_plea(inputs)
	if (locale === "pt") return pt_failed_to_start_checkout_plea(inputs)
	return ko_failed_to_start_checkout_plea(inputs)
});